import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAppConfig } from '../../config/config';
import { prepareAuthHeaders } from '../../config/authConfig';
import { Application, PanelType } from '../../types/domainTypes';

export const productDataApi = createApi({
  reducerPath: 'productDataApi',
  baseQuery: fetchBaseQuery({ prepareHeaders: prepareAuthHeaders }),
  tagTypes: ['ProductData'],
  endpoints: (builder) => ({
    getProducts: builder.query<PanelType[], { divisionName: string; panelType: Application }>({
      query: ({ divisionName, panelType }) => {
        const pt = panelType === Application.RoofPanel ? 'Roof' : 'Wall';
        const url = `${getAppConfig().apiUrl}/ProductData?panelType=${pt}&divisionName=${divisionName}`;

        return { url: url, method: 'GET' };
      },
    }),
    getDivisions: builder.query<string[], null>({
      query: () => {
        const url = `${getAppConfig().apiUrl}/ProductData/divisionNames`;

        return { url: url, method: 'GET' };
      },
    }),
  }),
});

export const { useGetDivisionsQuery, useGetProductsQuery, util } = productDataApi;
